/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersUpdateInternal } from '../../models/members-update-internal';
import { MembersWithoutSupplierData } from '../../models/members-without-supplier-data';

export interface UpdateMemberInternalV2MembersOrgIdPatch$Params {
  org_id: string;
  org: string;
      body: MembersUpdateInternal
}

export function updateMemberInternalV2MembersOrgIdPatch(http: HttpClient, rootUrl: string, params: UpdateMemberInternalV2MembersOrgIdPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
  const rb = new RequestBuilder(rootUrl, updateMemberInternalV2MembersOrgIdPatch.PATH, 'patch');
  if (params) {
    rb.path('org_id', params.org_id, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithoutSupplierData>;
    })
  );
}

updateMemberInternalV2MembersOrgIdPatch.PATH = '/_internal/v2/members/{org_id}';
